'use client'

import AirspaceAlertWrapper from '@/src/components/common/home/common/airspaceAlert'
import EmptyFlightScreenWrapper from '@/src/components/common/srp/emptyFlightScreen'
import AirlineFilterWrapperTopBar from '@/src/components/common/srp/filters/airlineFilterTopBar'
import SelectedFlightFilter from '@/src/components/common/srp/filters/sameAirlineFilterRT'
import SwipeableDrawerWithBackNavigation from '@/src/components/common/ui/swipeableDrawer'

import NearbyAirportPopup from '@/src/components/common/srp/nearbyAirportPopup'
import SignInPromoBannerWrapper from '@/src/components/common/signInPromoBanner'
import { SmartPreferenceBanner } from '@/src/components/common/srp/smartPreferenceBanner'
import FareFamilyWrapper from '@/src/components/desktop/srp/fareFamily'
import { Plan } from '@/src/components/desktop/srp/fareFamily/types'
import { MOBILE } from '@/src/constants/deviceTypes'
import ErrorBoundaryWrapper from '@/src/containers/common/ErrorBoundary'
import useClevertapForSrp from '@/src/hooks/analytics/clevertap/srp'
import useSrpGtmEvent from '@/src/hooks/analytics/gtm/srp'
import useNearByAirportAlertManager from '@/src/hooks/srp/nearbyAirportAlertManager'
import { useRTSolutionFlowManager } from '@/src/hooks/srp/RTSolutionView/RTSolutionFlowManager'
import useSearchResults from '@/src/hooks/srp/useSearchResults'
import { selectSRPFloatingAIChatEnabled } from '@/src/redux/slices/aiFeatureSlice'
import { useAppSelector } from '@/src/redux/store'
import { FlightCard } from '@/src/types/flight'
import { getSmartPreferenceSectionState } from '@/src/utils/srp/aiRecommendation/preferenceSectionState/smartPreferenceSections'
import { Box, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { FC, useCallback, useEffect } from 'react'
import ReactList from 'react-list'
import FullPageLoader from '../../fullPageLoader'
import FlightDetailsWrapper from '../flightDetails'
import SrpFilterAndSortTabsAndDrawerWrapper from '../srpFilterAndSortTabsBar/srpFilterAndSortTabsAndDrawerWrapper'
import LegInfo from './legInfo'
import { TransitionLoader } from './legTransitionLoader'
import RtSolutionCardWrapper from './rtSolutionCardWrapper'
import { ScrollToTopElement } from './scrollToTopElem'
import { SelectedOnwardLegPricingLabel } from './selectedOnwardLegPricingLabel'
import { StepTabs } from './steptabs'
interface RTSolutionFlowWrapperProps {
    handleFlightBook?: (cards: FlightCard[], fareFamilyData?: (Plan | null)[]) => void
}

const RTSolutionFlowWrapperMobile: FC<RTSolutionFlowWrapperProps> = ({ handleFlightBook }) => {
    const srpFloatingAIChatEnabled = useAppSelector(selectSRPFloatingAIChatEnabled)
    const { pushEventToDataLayer } = useSrpGtmEvent()
    const { triggerSrpEvent } = useClevertapForSrp()
    const {
        priceGroupEntries,
        preferredPriceGroupEntries,
        nonPreferredPriceGroupEntries,
        selectedOnwardCard,
        changeJourneyLegTo,
        handleSelectCard,
        returnLegsTransition,
        handleOpenViewDetails,
        cardDetails,
        handleCloseViewDetails,
        sectors,
        sid,
        jsons,
        showEmptyFlightScreen,
        selectedJourneyLeg,
        fareFamilyPopup,
        closeFareFamilyPopup,
        handleSelectFareFamilyPlan,
        selectedOnwardFareFamilyPlan,
        isFareFamilyLoading,
        fareFamilyLoadingMessage,
        smartSortIdMetrics
    } = useRTSolutionFlowManager({ handleFlightBook, deviceType: MOBILE })
    const { selectedSortForSelectedJourneyLeg } = useSearchResults()
    const tCommon = useTranslations('common')
    const isSmartSort = selectedSortForSelectedJourneyLeg?.sortKey === 'smart'
    const {
        primaryEntries,
        secondaryEntries,
        shouldShowBannerBeforePrimary,
        shouldShowBannerBeforeSecondary,
        bannerVariant
    } =
        getSmartPreferenceSectionState({
            preferredEntries: preferredPriceGroupEntries,
            nonPreferredEntries: nonPreferredPriceGroupEntries,
            fallbackEntries: priceGroupEntries,
            isSmartSort
        })

    const {
        handleFlightSelection,
        handleNearbyPopupContinue,
        handleNearbyPopupClose,
        isOpen: nearbyPopupOpen,
        popupData: nearbyPopupData
    } = useNearByAirportAlertManager({
        onContinue: handleSelectCard,
        jsons: jsons || null,
        sectors: sectors || null,
        selectedJourneyLeg, // Pass the current leg (0 or 1)
        handleFlightDetailsClose: handleCloseViewDetails
    })



    useEffect(() => {
        triggerSrpEvent('Air_PageLoad', {
            page_load_time: Math.round(performance.now())
        })
        pushEventToDataLayer({
            event: 'page_view_flight_search_results',
            page_category: 'home'
        })
    }, [])
    // const topSortedCards = useGetSortedTopCards()

    const renderFlightCard = useCallback(
        (entries: typeof priceGroupEntries, index: number) => {
            const [groupKey, cards] = entries[index]
            // 4th slot in primary SRP list
            const signInPromoSlot = index === 3 ? <SignInPromoBannerWrapper /> : null

            return (
                <ErrorBoundaryWrapper
                    identifier="rt-solution-card-wrapper-PWA-RT-solution-flow"
                    key={groupKey}
                    fallback={null}
                >
                    {signInPromoSlot}
                    <RtSolutionCardWrapper
                        samePriceCards={cards}
                        onSelectCard={handleFlightSelection}
                        onViewDetailsClick={handleOpenViewDetails}
                    />
                </ErrorBoundaryWrapper>
            )
        },
        [handleSelectCard, handleOpenViewDetails]
    )

    // const renderTopSortedCards = useCallback(() => {
    //     return (
    //         <Box p={1.5} borderRadius={1} bgcolor={"#F3F3F3"} mb={1} display={"flex"} flexDirection={"column"} gap={1}>
    //             {topSortedCards.map(sortOptions => (
    //                 <TopSortCardsBadge
    //                     key={sortOptions.id}
    //                     label={sortOptions.label}
    //                     isActive={!!sortOptions.isActive}
    //                     sortOptionId={sortOptions.id}
    //                     isMobile={true}
    //                     isCombined={sortOptions.isCombined}
    //                 >
    //                     <Card
    //                         sx={{
    //                             border: '1px solid #eee',
    //                             borderRadius: 2,
    //                             background: '#fff',
    //                             transition: 'border 0.2s, padding 0.2s',
    //                             position: 'relative'
    //                         }}
    //                     >
    //                         <Box height={"15px"}></Box>
    //                         <YellowBannerPromo promos={sortOptions?.card?.promos} isMobile />
    //                         {!!sortOptions?.card?.promos?.length && <Box height={"15px"}></Box>}
    //                         <Box
    //                             sx={{
    //                                 pt: (sortOptions?.card?.promos?.length || 0) > 0 ? 1 : 0
    //                             }}
    //                         >
    //                             <RtSolutionCard
    //                                 card={sortOptions?.card!}
    //                                 onSelectCard={handleFlightSelection}
    //                                 onViewDetailsClick={handleOpenViewDetails}
    //                             />
    //                         </Box>
    //                     </Card>
    //                 </TopSortCardsBadge>
    //             ))}
    //         </Box>
    //     )
    // }, [handleFlightSelection, handleOpenViewDetails, topSortedCards])



    return (
        <>
            <Box sx={{ flex: 1, overflow: 'auto' }}>
                <AirspaceAlertWrapper />
                <ScrollToTopElement />
                {returnLegsTransition && selectedOnwardCard && (
                    <ErrorBoundaryWrapper identifier="transition-loader-PWA-RT-solution-flow">
                        <TransitionLoader
                            onwardFlightData={selectedOnwardCard}
                            selectedOnwardFareFamilyPlan={selectedOnwardFareFamilyPlan}
                        />
                    </ErrorBoundaryWrapper>
                )}

                {/* {selectedOnwardCard && (
                    <ErrorBoundaryWrapper identifier="master-tuple-wrapper-PWA-RT-solution-flow">
                        <MasterTupleWrapper
                            onwardFlightData={selectedOnwardCard}
                            onChangeOnwardSelection={() => changeJourneyLegTo(0)}
                            selectedOnwardFareFamilyPlan={selectedOnwardFareFamilyPlan}
                        />
                    </ErrorBoundaryWrapper>
                )} */}
                <Box
                    position={'sticky'}
                    top={0}
                    zIndex={1000}
                    bgcolor={'#fff'}
                >
                    <ErrorBoundaryWrapper identifier="step-tabs-PWA-RT-solution-flow">
                        <StepTabs onwardFlightData={selectedOnwardCard}
                            onChangeOnwardSelection={() => changeJourneyLegTo(0)} />
                    </ErrorBoundaryWrapper>

                    {selectedOnwardCard && <SelectedOnwardLegPricingLabel onwardFlightData={selectedOnwardCard} selectedOnwardFareFamilyPlan={selectedOnwardFareFamilyPlan} />}
                    <ErrorBoundaryWrapper identifier="leg-info-PWA-RT-solution-flow">
                        <LegInfo selectedLeg={selectedJourneyLeg} />
                    </ErrorBoundaryWrapper>
                </Box>


                <Box sx={{ display: 'flex', flexDirection: 'column', px: 1 }}>
                    <ErrorBoundaryWrapper identifier="airline-filter-wrapper-top-bar-PWA-RT-solution-flow">
                        <AirlineFilterWrapperTopBar showArrows={false} deviceType={MOBILE} />
                    </ErrorBoundaryWrapper>
                </Box>

                <Box sx={{ display: 'flex', flexDirection: 'column', backgroundColor: '#F9FAFB' }}>
                    <ErrorBoundaryWrapper identifier="srp-filter-and-sort-tabs-and-drawer-wrapper-PWA-RT-solution-flow">
                        <SrpFilterAndSortTabsAndDrawerWrapper showEmptyFlightScreen={showEmptyFlightScreen} />
                    </ErrorBoundaryWrapper>

                    {selectedOnwardCard && (
                        <ErrorBoundaryWrapper
                            fallback={null}
                            identifier="srp-selected-same-flight-filter-PWA-RT-solution-flow"
                        >
                            <SelectedFlightFilter onwardFlightData={selectedOnwardCard} />
                        </ErrorBoundaryWrapper>
                    )}
                    {showEmptyFlightScreen ? (
                        <ErrorBoundaryWrapper identifier="empty-flight-screen-wrapper-PWA-RT-solution-flow">
                            <EmptyFlightScreenWrapper deviceType={MOBILE} />
                        </ErrorBoundaryWrapper>
                    ) : (
                        <>
                            {/* {renderTopSortedCards()} */}
                            <Box
                                px={1}
                                sx={
                                    srpFloatingAIChatEnabled
                                        ? {
                                            pb: 'calc(300px + env(safe-area-inset-bottom, 0px))'
                                        }
                                        : undefined
                                }
                            >
                                {shouldShowBannerBeforePrimary && (
                                    <SmartPreferenceBanner tCommon={tCommon} variant={bannerVariant} compact />
                                )}
                                <ReactList
                                    length={primaryEntries.length}
                                    itemRenderer={index => renderFlightCard(primaryEntries, index)}
                                />
                                {shouldShowBannerBeforeSecondary && (
                                    <SmartPreferenceBanner tCommon={tCommon} variant={bannerVariant} compact />
                                )}
                                <ReactList
                                    length={secondaryEntries.length}
                                    itemRenderer={index => renderFlightCard(secondaryEntries, index)}
                                />
                            </Box>
                        </>
                    )}
                </Box>
            </Box >

            <SwipeableDrawerWithBackNavigation open={!!cardDetails} onClose={handleCloseViewDetails} anchor="bottom">
                {cardDetails && (
                    <ErrorBoundaryWrapper identifier="flight-details-wrapper-PWA-RT-solution-flow">
                        <FlightDetailsWrapper
                            flights={cardDetails.cards}
                            sectors={sectors!}
                            jsons={jsons!}
                            onSelect={() => handleFlightSelection(cardDetails.cards[1] || cardDetails.cards[0], cardDetails?.cards?.length === 2)}
                            sid={sid!}
                            isRTSolutionView={true}
                            showBaggage={cardDetails.showBaggage}
                        />
                    </ErrorBoundaryWrapper>
                )}
            </SwipeableDrawerWithBackNavigation>

            <SwipeableDrawerWithBackNavigation
                open={!!fareFamilyPopup}
                onClose={closeFareFamilyPopup}
                anchor="bottom"
                keepMounted
            >
                <ErrorBoundaryWrapper identifier="fare-family-wrapper-PWA">
                    <FareFamilyWrapper
                        flight={fareFamilyPopup?.card}
                        sectors={sectors!}
                        handleClose={closeFareFamilyPopup}
                        handleCreateBooking={handleSelectFareFamilyPlan}
                        jsons={jsons!}
                        desktop={false}
                        rawFareFamilyData={fareFamilyPopup?.fareFamilyData}
                        key={selectedJourneyLeg}
                    />
                </ErrorBoundaryWrapper>
            </SwipeableDrawerWithBackNavigation>

            <NearbyAirportPopup
                open={nearbyPopupOpen}
                onClose={handleNearbyPopupClose}
                onContinue={handleNearbyPopupContinue}
                data={nearbyPopupData}
            />

            {
                isFareFamilyLoading && (
                    <FullPageLoader
                        message={
                            <Box mt={3} textAlign="center">
                                <Typography variant="h6" fontWeight={700} color="text.secondary">
                                    {fareFamilyLoadingMessage}
                                </Typography>
                            </Box>
                        }
                    />
                )
            }
        </>
    )
}

export { RTSolutionFlowWrapperMobile as RTSolutionFlowWrapper }
export default RTSolutionFlowWrapperMobile
